// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"9":"8508717b","562":"8508717b","869":"fb236ab5"}[chunkId] + ".chunk.css";
};